import {
    type SxProps,
    type Theme,
    alpha
} from '@mui/material/styles';

const styles = {
    carousel: (theme) => ({
        '.slick-arrow': {
            '&::after': {
                transform: 'translate(-50%, -50%) rotate(-45deg)'
            },

            '&::before': {
                mt: '2px',
                transform: 'translate(-50%, -50%) rotate(45deg)'
            },

            '&::before, &::after': {
                backgroundColor: theme.colors.plantation,
                borderRadius: 2,
                content: '""',
                height: 4,
                left: '50%',
                opacity: 1,
                position: 'absolute',
                top: '50%',
                transformOrigin: 'center right',
                width: 14
            },

            ':hover': {
                transform: 'translate(0) scale(1.05)'
            },

            alignItems: 'center',
            backgroundColor: 'transparent',
            border: `solid 1px ${theme.colors.plantation}`,
            borderRadius: '50%',
            display: 'flex !important',
            height: 40,
            justifyContent: 'center',
            position: 'absolute',
            transform: 'translate(0)',
            width: 40,
            zIndex: 1
        },

        '.slick-disabled': {
            display: 'none !important'
        },

        '.slick-list': {
            mx: {
                md: -2,
                xs: 0
            }
        },

        '.slick-next': {
            right: '-62px'
        },

        '.slick-prev': {
            ':hover': {
                transform: 'translate(0) scaleX(-1) scale(1.05)'
            },
            left: '-62px',
            transform: 'translate(0) scaleX(-1)'
        },

        '.slick-slide': {
            boxSizing: 'border-box',
            px: 2
        },

        '.slick-slide > div > div': {
            width: '100% !important'
        },

        '.slick-track': {
            pt: 1
        },

        mt: {
            md: 5,
            xs: 4
        },
        mx: -2
    }),

    container: {
        boxSizing: 'border-box',
        maxWidth: 1728,
        width: '100%'
    },

    divider: (theme) => ({
        borderColor: theme.colors.mercury,
        borderWidth: 1,
        mb: {
            md: 9,
            xs: 3
        },
        mt: {
            md: 6,
            xs: 3
        }
    }),

    featuredSupporterWrapper: () => ({ }),

    thumbnailSmall: (theme) => ({
        boxShadow: `0px 0px 5px ${alpha(theme.colors.black, 0.22)}`, // ~ #00000038
        boxSizing: 'border-box',
        display: 'inline-block',
        img: {
            width: {
                lg: 150,
                md: 130,
                xs: 120
            }
        },
        mt: 1,
        p: 0.5
    }),

    wrapper: {
        alignItems: 'flex-start',
        boxSizing: 'border-box',
        display: 'flex',
        justifyContent: 'center',
        overflowX: 'hidden',
        paddingTop: 5,
        width: '100%'
    }
} satisfies Record<string, SxProps<Theme>>;

export default styles;
